import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import LockIcon from '../icons/LockIcon';

import PiggyBankLabelCircledIcon from '../icons/PiggyBankLabelCircledIcon';

import { ListingCostItemShape } from '../../constants/shapes';

import PaymentTimelineCard from './PaymentTimelineCard';
import PaymentTimeLineItem from './PaymentTimelineItem';

const OnCheckIn = ({
  hasNoDeposit,
  isPricingCalculated,
  costs = {},
  currencyCode,
  isCollapsed = false
}) => {
  const totalValue = isPricingCalculated
    ? formatPrice(costs.total, currencyCode)
    : trans('book_now_modal.dates_input.label');

  const depositTag = hasNoDeposit
    ? {
        label: trans('search.filter.no-deposit.vp.title'),
        renderLeadingIcon: () => (
          <PiggyBankLabelCircledIcon width="15" height="18" />
        ),
        isSpaced: true,
        underlined: true,
        size: 'big'
      }
    : {
        label: trans('homecard.label.deposit.protected'),
        renderLeadingIcon: () => <LockIcon width="15" height="18" />,
        isSpaced: true,
        underlined: true,
        size: 'big'
      };

  if (isPricingCalculated && costs.total === 0) {
    return null;
  }

  return (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.on_check_in.title')}
      value={totalValue}
      tags={[depositTag]}
      collapsible
      isCollapsed={isCollapsed}
    >
      {costs?.costs?.map(cost => (
        <PaymentTimeLineItem
          key={cost.type}
          title={trans(`payment.timeline.cost.label.${cost.type}`)}
          value={cost.value}
          currencyCode={currencyCode}
        />
      ))}
    </PaymentTimelineCard>
  );
};

OnCheckIn.propTypes = {
  hasNoDeposit: PropTypes.bool.isRequired,
  isPricingCalculated: PropTypes.bool.isRequired,
  costs: PropTypes.shape(ListingCostItemShape),
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool
};

export default OnCheckIn;
